import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import iconFlagEn from '@assets/icon-flag-en.svg';
import iconFlagDe from '@assets/icon-flag-de.svg';
import iconFlagFr from '@assets/icon-flag-fr.svg';
import iconFlagNl from '@assets/icon-flag-nl.svg';
import iconFlagIt from '@assets/icon-flag-it.svg';
import iconFlagPl from '@assets/icon-flag-pl.svg';
import iconFlagPt from '@assets/icon-flag-pt.svg';
import iconFlagBg from '@assets/icon-flag-bg.svg';
import iconFlagRo from '@assets/icon-flag-ro.svg';
import iconFlagNo from '@assets/icon-flag-no.svg';
import iconFlagDa from '@assets/icon-flag-da.svg';
import iconFlagSk from '@assets/icon-flag-sk.svg';
import iconFlagEs from '@assets/icon-flag-es.svg';
import iconFlagCa from '@assets/icon-flag-ca.svg';
import { isInUrl } from '@src/shared/utils';

interface ILanguage {
  title: string;
  img: string;
  enabled: boolean;
  alias?: string;
}

export const defaultLang = 'en';

export const languageQueryParam = 'kc_locale';

export const languages: { [key: string]: ILanguage } = {
  en: { title: 'English', img: iconFlagEn, enabled: true },
  de: { title: 'Deutsch', img: iconFlagDe, enabled: true },
  fr: { title: 'Français', img: iconFlagFr, enabled: true },
  'fr-be': { title: 'Français', img: iconFlagFr, enabled: false, alias: 'fr' },
  nl: { title: 'Nederlands', img: iconFlagNl, enabled: true },
  it: { title: 'Italian', img: iconFlagIt, enabled: true },
  pl: { title: 'Polski', img: iconFlagPl, enabled: true },
  pt: { title: 'Portugues', img: iconFlagPt, enabled: true },
  bg: { title: 'Bulgarian', img: iconFlagBg, enabled: true },
  ro: { title: 'Romanian', img: iconFlagRo, enabled: true },
  no: { title: 'Norsk', img: iconFlagNo, enabled: true },
  da: { title: 'Dansk', img: iconFlagDa, enabled: true },
  dk: { title: 'Dansk', img: iconFlagFr, enabled: false, alias: 'da' },
  he: { title: 'Hebrew', enabled: isInUrl('apps'), img: '' },
  sk: { title: 'Slovenský', enabled: true, img: iconFlagSk },
  es: { title: 'Spanish', enabled: true, img: iconFlagEs },
  ca: { title: 'Catalá', enabled: true, img: iconFlagCa },
  iw: { title: 'Hebrew', enabled: false, img: '', alias: 'he' },
  heb: { title: 'Hebrew', enabled: false, img: '', alias: 'he' },
};

export const isLanguageActive = (languageKey: string) => {
  const possibleAlias: string = languages[languageKey]?.alias || '';
  return languages[languageKey]?.enabled || languages[possibleAlias]?.enabled;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: (code) => {
      const alias = languages[code] && languages[code].alias;
      if (alias) {
        i18n.changeLanguage(alias);
        return [alias, defaultLang];
      } else {
        return [defaultLang];
      }
    },
    debug: process.env.NODE_ENV === 'development',
    ns: ['translations'],
    defaultNS: 'translations',
    load: 'all', // 'languageOnly', // This will parse 'en' from 'en-US',
    lowerCaseLng: true,
    cleanCode: true,
    interpolation: {
      formatSeparator: ',',
    },
    react: {
      wait: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'url'],
    },
    backend: {
      loadPath: `${
        !isInUrl('apps') ? process.env.TRANSLATIONS_URL : process.env.TRANSLATIONS_URL_SCOOBER
      }/{{lng}}/{{ns}}.json`,
      addPath: `${
        !isInUrl('apps') ? process.env.TRANSLATIONS_URL : process.env.TRANSLATIONS_URL_SCOOBER
      }/{{lng}}/{{ns}}.missing.json`,
      jsonIndent: 2,
    },
  });

export default i18n;
